<template>
  <v-row>
    <v-col sm="1" lg="2" class="hidden-xs-only">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            small
            fixed
            exact
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="regresar"
          >
            <v-icon> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>Regresar</span>
      </v-tooltip>
    </v-col>
    <v-col cols="12" sm="10" lg="8">
      <DetailCard title="Detalles Participante" :loading="cardLoading">
        <v-row justify="center">
          <v-col
            v-for="(item, index) in participante"
            :key="index"
            cols="12"
            sm="10"
            lg="8"
          >
            <p class="text-h6 font-weight-bold">
              {{ item.label }}
            </p>
            <template v-if="item.value != null">
              <p class="text-subtitle-1">
                {{ item.value }}
              </p>
            </template>
            <template v-else>
              <p class="text-subtitle-1">No registrado</p>
            </template>
          </v-col>
        </v-row>
      </DetailCard>
    </v-col>
  </v-row>
</template>

<script>
import DetailCard from "../../../components/admin/DetailCard.vue";
export default {
  data: () => ({
    cardLoading: true
  }),
  mounted() {
    this.$store.dispatch("gestionarParticipantesWorldskills");
    setTimeout(() => {
      this.cardLoading = false;
    }, 1000);
  },
  components: {
    DetailCard,
  },
  computed: {
       participante() {
      const participante = this.$store.getters.obtenerParticipanteWorldskills(
        this.$route.params.id_participante
      );
      
      const participantes = [
        {
          label: "Tipo de Identificación",
          value: participante.tipo_identificacion,
        },
        {
          label: "Identificación",
          value: participante.identificacion,
        },

        {
          label: "Nombres",
          value: participante.nombres,
        },

        {
          label: "Apellidos",
          value: participante.apellidos,
        },

        {
          label: "Telefono Movil",
          value: participante.telefono_movil,
        },

        {
          label: "Correo Electrónico",
          value: participante.correo,
        },

        {
          label: "Dirección",
          value: participante.direccion,
        },
        {
          label: "Fecha de Nacimiento",
          value: participante.fecha_nacimiento,
        },
        {
          label: "Genero",
          value: participante.genero,
        },
        {
          label: "Estado Civil",
          value: participante.estado_civil,
        },
        {
          label: "Estrato",
          value: participante.estrato,
        },{
          label: "Zona",
          value: participante.zona,
        },
        {
          label: "Discapacidad",
          value: participante.discapacidad,
        },
        {
          label: "Talla de Camiseta",
          value: participante.talla_camiseta,
        },
        {
          label: "Programa de Formación",
          value: participante.programa_formacion,
        },
        {
          label: "Número de Ficha",
          value: participante.numero_ficha,
        },
        {
          label: "Regional",
          value: participante.regional,
        },
        {
          label: "Centro de Formación",
          value: participante.centro_formacion,
        },
        {
          label: "Habilidad",
          value: participante.categoria,
        },
        {
          label: "Competencia",
          value: participante.competencia,
        },
        
      ];
      return participantes;
    },
  },

  methods: {
    regresar() {
      this.$router.back()
    }
  }
};
</script>
